import application from './applicationService'
import hubService from './hubService'

export default {
  application: application,
  hub: hubService
}
